export interface UpdateAuthorityRequest {
  authorityType: string
  authorityNo: string
  authorities: {
    tag: string
    data: string
    revision: number
  }[]
}

export function UpdateAuthorityRequestToJSON(
  value: UpdateAuthorityRequest
): any {
  return {
    authority_type:
      value.authorityType !== '' ? value.authorityType : undefined,
    authority_no: value.authorityNo !== '' ? value.authorityNo : undefined,
    authorities:
      value.authorities.length > 0
        ? value.authorities.map(authority => {
            return {
              tag: authority.tag !== '' ? authority.tag : undefined,
              data: authority.data !== '' ? authority.data : undefined,
              revision:
                authority.revision !== 0 ? authority.revision : undefined
            }
          })
        : []
  }
}
